import React, { useEffect, useRef, useState } from 'react';
//import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';

const useDocumentViewer = (document: any) => {
    /**
     * load the report when the document changes
     */
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (document) {
            loadSelectedReport();
        }
    }, [document]);

    const loadSelectedReport = async () => {
        //Stimulsoft.Base.StiLicense.loadFromFile('path/to/license.key'); // Load your license key
        const options = new (
            window as any
        ).Stimulsoft.Viewer.StiViewerOptions();
        options.appearance.fullScreenMode = false;
        options.appearance.scrollbarsMode = false;

        const viewer = new (window as any).Stimulsoft.Viewer.StiViewer(
            options,
            'StiViewer',
            false
        );

        viewer.report = document;

        viewer.report.renderAsync(() => {
            //after we render the report we can render the viewer
            viewer.renderHtml('reportViewer');
            setIsLoading(false);
        });

        // Render the viewer in the designated element
    };

    return { isLoading };
};

export default useDocumentViewer;
